
const Basvuru = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Application</h2>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12 mt-4">
          <p>Companies and entrepreneurs seeking to operate within POLSAN S&T Park to benefit from the provisions of Law No. 4691 on Technology Development Zones and other relevant legislation can complete the entire application process through the online portal.</p>
          <p>The application process begins when the applicant completes the digital form and uploads the required supporting documents. Following submission, an authorized representative of the Managing Company reviews the application and its annexes. Any identified deficiencies or necessary revisions are communicated to the applicant for correction. In line with this feedback, the applicant revises and resubmits the form for further review. This iterative review, evaluation, and revision cycle continues until the application is finalized for official assessment.</p>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="d-grid col-md-2 col-sm-6 mx-auto">
          <a href="https://basvuru.polsanteknokent.com.tr" className="btn btn-primary btn-lg btn-basvuru" role="button" target="_blank">APPLICATION</a>
        </div>
      </div>
    </>
  );
};

export default Basvuru;
